export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOG01.a0159fb8.mp3";